module.exports = __webpack_public_path__ + "static/media/google-play-en.b37d0b93.png";